const I18N_WHITELIST = ['en', 'zh-CN', 'fr', 'fr-CA', 'pt', 'pt-BR', 'ja', 'es', 'de', 'ru', 'ko', 'it', 'tr', 'pl', 'cs', 'nl', 'da'];

module.exports = {
    I18N_WHITELIST
};
